// Components
import { Link } from '@tracklib/kit'

import styles from './subscriptionterms.css'

interface SubscriptionTermsProps {
  buttonText: string
  eligbleForTrial?: boolean
}

const SubscriptionTerms = ({ buttonText, eligbleForTrial }: SubscriptionTermsProps): JSX.Element => (
  <p className={styles.terms}>
    By clicking &quot;{buttonText}&quot; you agree to our{' '}
    <Link href="/terms" target="_blank" className={styles.termsLink}>
      Terms and Conditions
    </Link>{' '}
    and{' '}
    <Link href="/privacy" target="_blank" className={styles.termsLink}>
      Privacy Policy
    </Link>
    . You will be billed automatically according to your chosen plan
    {eligbleForTrial ? ' at the end of your free period.' : '.'}
  </p>
)

export default SubscriptionTerms
